import Vue from 'vue'
import Router, { RouterOptions, Route } from 'vue-router'
import Component from 'vue-class-component'

import store from '@/system/store'
import { routes } from './routerConfig'
import {
  IMiddlewareContext,
  requireAuth,
  middlewarePipeline,
  checkWsConnectionAndConnect
} from './middlewares'

Component.registerHooks([
  'beforeRouteLeave'
])

Vue.use(Router)

const routerOptions: RouterOptions = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...routes
  ]
}

const router = new Router(routerOptions)

const middlewares = [requireAuth, checkWsConnectionAndConnect]

router.beforeEach((to: Route, from: Route, next: () => void) => {
  if (to.path !== '/callback') {
    const [middleware, ...restMiddlewares] = middlewares

    const context: IMiddlewareContext = {
      to,
      from,
      next,
      store
    }

    return middleware({
      ...context,
      next: middlewarePipeline(context, restMiddlewares)
    })
  }
  next()
})

export default router
